import ZingTouch from 'zingtouch';
import { getCardinalDirection } from '../helpers/ZingTouchHelper';
import gsap from 'gsap';




export default class TrackBar {
	#root;
	#bar;
	#onChangeCall;
	#touchableRegion;
	
	constructor(element, touchableRegion = null) {
		this.#root = element;
		this.#touchableRegion = touchableRegion || element;
		this.#bar = element.querySelector('.ui-scroll-state--track');
		this.attachEvents();
	}
	
	
	attachEvents() {
		const _this = this;
		const useSwipe = false;
		
		if( useSwipe ) {
			const region = ZingTouch.Region(this.#touchableRegion, false, false);
			
			region.bind(this.#bar, 'pan', event => {
				// Within each of those special ZingTouch events, 
				// the originalEvent the browser emitted is stored.
				event.detail.events.forEach(e => e.originalEvent.preventDefault());
				_this.#onPan(event);
			}, false);
		}
		
		this.#root.addEventListener('click', event => {
			const position = Math.round((event.offsetX / this.#root.offsetWidth) * 5) * 20; // round to nearest 20%
			_this.triggerOnChange(position);
		});
	}
	
	
	
	#onPan(event) {
		const { currentDirection, distanceFromOrigin } = event.detail.data[0];
		const direction = getCardinalDirection(currentDirection);
		const distance = direction === 'W' ? distanceFromOrigin * -1 : distanceFromOrigin;
		const currentValue = _this.getCurrentPosition();
		const maxX = _this.getMaxPosition();
		const x = gsap.utils.clamp(0, maxX, currentValue + distance);
		
		gsap.to(_this.#bar, { 
			x,
			duration: .5,
			onUpdate: () => _this.triggerOnChange( (x / maxX) * 100 ),
		});
	}
	
	
	//in %
	getPosition() {
		return (this.getCurrentPosition() / this.getMaxPosition()) * 100;
	}
	
	// position equiv to left:100%, 
	// but in pixels
	getMaxPosition() {
		return this.#root.offsetWidth - this.#bar.offsetWidth; 
	}
	
	// in pixels
	getCurrentPosition() {
		return gsap.getProperty(this.#bar, 'x');
	}
	
	setPercentage(value) {
		const maxX = this.getMaxPosition();
		const x = maxX * (value / 100);
		gsap.to(this.#bar, { x, duration: .25 });
	}
	
	setScrollWidth(value) {
		this.#bar.style.width = value;
	}
	
	onChange(callable) {
		this.#onChangeCall = callable;
	}
	
	triggerOnChange(position) {
		this.#onChangeCall && this.#onChangeCall(position);
	}
}